import { LISTA_PERMISSOES } from '../util/listaPermissoes'

export const rotasAdministrativo = [
    {
        path: "/adm/empresas",
        name: 'Empresas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/empresas/empresasListagem'),
    },
    {
        path: "/adm/cobrancapix",
        name: 'CobrancaPix',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/efipagamentos/cobrancaPixListagem'),
    },
    {
        path: "/adm/cobrancapix/:id",
        name: 'CobrancaPixEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/efipagamentos/cobrancaPixEditar'),
    },
    {
        path: "/adm/licencas",
        name: 'Licencas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/licencas/licencasListagem'),
    },
    {
        path: "/adm/licencas/:id",
        name: 'LicencasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/licencas/licencasEditar'),
    },
    {
        path: "/adm/usuarios",
        name: 'Usuarios',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/usuarios/usuariosListagem'),
    },
    {
        path: "/adm/usuarios/:id",
        name: 'UsuariosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/usuarios/usuariosEditar'),
    },
    {
        path: "/adm/parametros",
        name: 'Parametros',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/parametrosSistema'),
    },
    {
        path: "/adm/empresas/:id",
        name: 'EmpresasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/empresas/empresasEditar'),
    },
    {
        path: "/adm",
        name: 'AdmDashBoard',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/dashBoard'),
    },
    {
        path: "/adm/pessoas",
        name: 'CadPessoas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/gen/pessoas/pessoasListagem'),
    },
    {
        path: "/adm/pessoas/:id",
        name: 'PessoasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/gen/pessoas/pessoasEditar')
    },
    {
        path: "/adm/planos",
        name: 'Planos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/planos/planosListagem'),
    },
    {
        path: "/adm/planos/:id",
        name: 'PlanosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/planos/planosEditar'),
    },
    {
        path: "/adm/provedoria",
        name: 'Provedoria',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/provedoria/provedoriaListagem'),
    },
    {
        path: "/adm/provedoria/:id",
        name: 'ProvedoriaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/provedoria/provedoriaEditar'),
    },
    {
        path: "/adm/sigtap",
        name: 'SigtapImportacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/sde/sus/sigtapImportacao'),
    },
    {
        path: "/adm/empresamodulos",
        name: 'EmpresaModulos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/empresamodulo/empresamoduloListagem'),
    },
    {
        path: "/adm/empresamodulos/:id",
        name: 'EmpresaModulosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/empresamodulo/empresamoduloEditar'),
    },
    {
        path: "/adm/clientes",
        name: 'ClientesAdmin',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/clientesadmin/clientesAdminListagem'),
    },
    {
        path: "/adm/clientes/:id",
        name: 'ClientesAdminEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER],
        },
        component: () => import('@/views/pdr/clientesadmin/clientesAdminEditar'),
    },
]
